import { useEffect, useState } from 'react';
import dateDiffToDate from 'helper/dateDiffToDate';
import { GenericResponse } from 'services/api/base';
import { PreferenceList } from 'services/api/Meteorology';
import { MeteorologyViewMode } from 'redux/reducers/meteorologyFieldsObservedDataControlPanelReducer';

export default function useLoadFirstPreference({
  data,
  preferenceList,
  resetPreferences,
  setPeriod,
  setModelArray,
  setRegion,
  setAnomaly,
  setForecastUnixDate,
  controlPanelUsed,
  setVariable,
  setViewMode,
  requestConsult,
}: {
  data: GenericResponse<PreferenceList[], string> | undefined,
  preferenceList: PreferenceList[],
  resetPreferences: () => void,
  setPeriod: (period: string) => void,
  setModelArray: (models: string[]) => void,
  setRegion: (region: string) => void,
  setAnomaly: (anomaly: boolean) => void,
  setForecastUnixDate: (value: Date | null) => void,
  controlPanelUsed: boolean,
  setVariable: (variable: string) => void,
  setViewMode: (viewMode: MeteorologyViewMode) => void,
  requestConsult: () => void,
}) {
  const [firstLoad, setFirstLoad] = useState(true);
  useEffect(() => {
    if (data === undefined || !firstLoad) {
      return;
    }
    setFirstLoad(false);
    if (preferenceList.length === 0 || controlPanelUsed) {
      return;
    }
    const preference = preferenceList[0];
    const today = new Date();
    const date = dateDiffToDate(preference.json.data_prev, [today]) || today;
    // Preferências salvas antes do Heatmap não têm tipo_visualizacao → 'spatial'.
    const viewMode = preference.json.tipo_visualizacao ?? 'spatial';

    resetPreferences();
    setPeriod(preference.json.periodo_interesse);
    setVariable(preference.json.variavel_meteorologica);
    setModelArray(preference.json.modelos);
    setRegion(preference.json.area_plotagem);
    setAnomaly(preference.json.anom);
    setForecastUnixDate(date);
    setViewMode(viewMode);

    // Dispara a consulta automaticamente quando a preferência carregada tem os
    // filtros mínimos necessários — assim o usuário não precisa clicar em
    // "Realizar consulta" ao entrar na tela com uma preferência salva.
    const hasModels = (preference.json.modelos ?? []).length > 0;
    const canQuery = viewMode === 'heatmap'
      ? Boolean(preference.json.variavel_meteorologica && hasModels)
      : Boolean(
        preference.json.area_plotagem && hasModels && preference.json.periodo_interesse,
      );
    if (canQuery) {
      requestConsult();
    }
  }, [firstLoad,
    data,
    preferenceList,
    resetPreferences,
    setForecastUnixDate,
    setVariable,
    setModelArray,
    setPeriod,
    setRegion,
    setAnomaly,
    controlPanelUsed,
    setViewMode,
    requestConsult,
  ]);
}
